import * as tslib_1 from "tslib";
import { PurchaseFlow } from '../enums/purchase-flow.enum';
import { EventEmitter, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { MemberType } from '../enums/member-type.enum';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { MemberLevel } from '../enums/member-level.enum';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';
import { Portal, DisplaySectionId } from '../enums/document-type.enum';
import { MemberResourcesConstants } from '../constants/member-resources.constants';
import { MemberAllowedResourcesLookup } from '../enums/member-allowed-resources.enum';
import { HttpHeaders } from '@angular/common/http';
import { catchError, tap, map, mergeMap } from 'rxjs/internal/operators';
import { SharedConstants } from '../constants/shared.constants';
import { HamburgerItemConstants } from '../constants';
import { CountryPhoneNumberFormats } from '../constants/country-phonenumber-format.constant';
export class CommonService {
    constructor(_http, _cacheService, _configurationService, _activeSessionService, _appConfigService, 
    // private _reportOnlyCountryService: ReportOnlyCountryService,
    _authService) {
        this._http = _http;
        this._cacheService = _cacheService;
        this._configurationService = _configurationService;
        this._activeSessionService = _activeSessionService;
        this._appConfigService = _appConfigService;
        this._authService = _authService;
        this.widgetConfigUrl = environment.uiTemplateBaseUrl +
            '/test/productwidget.json?templateVersion=' + environment.templateVersion;
        this._headerurl = environment.uiTemplateBaseUrl +
            '/test/countries-languages.json?templateVersion=' + environment.templateVersion;
        this.cmsWidgetConfigUrl = environment.uiTemplateBaseUrl +
            '/test/widgetconfig.json';
        this._productGroupUrl = environment.cdnURL +
            '/flpi/catalog-json/product-groups.json?templateVersion=' + environment.templateVersion;
        this._accountServiceUrl = environment.apiUrl + '/account/V1/';
        // Collection of EventEmitter object;
        this._eventEmitters = {};
        this.thresholdCrossed = false;
        this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode).toUpperCase();
        this.appConfig = this._appConfigService.getSettings(this.isoCountryCode);
        this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    }
    ngOnInit() {
    }
    /**
     * Create a singleton EventEmitter Object
     *  for a given Id
     * @param Id {String}
     * @returns eventEmitter {EventEmitter}
     * */
    getEmitter(id) {
        if (this._eventEmitters[id] === undefined) {
            this._eventEmitters[id] = new EventEmitter();
        }
        return this._eventEmitters[id];
    }
    getProductGroupConfig() {
        return this._http
            .get(this._productGroupUrl)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**scroll element to specified offset height with duration */
    scrollTo(elementId, duration) {
        const element = $('#' + elementId);
        const headerElement = $('#global-banner');
        if (element[0]) {
            let hasFixedTop = false;
            let headerHeight = 0;
            if (headerElement) {
                hasFixedTop = headerElement.hasClass('fixed-top');
                headerHeight = hasFixedTop ? headerElement.height() : 120;
            }
            $('html, body').animate({
                scrollTop: element.offset().top - headerHeight
            }, duration);
        }
    }
    getPhoneNumberFormatByCountryCode(countryCode) {
        if (CountryPhoneNumberFormats.formats.find(item => item.countryCode === countryCode)) {
            return CountryPhoneNumberFormats.formats.
                find(item => item.countryCode === countryCode).phoneNumberMaskFormat;
        }
        else {
            return '(000) 000-0000';
        }
    }
    scrollToPromotionalContent(elementId, duration) {
        const element = $('#' + elementId);
        const headerElement = $('#promotion-banner');
        if (element[0]) {
            let hasFixedTop = false;
            let headerHeight = 0;
            if (headerElement) {
                hasFixedTop = headerElement.hasClass('fixed-top');
                headerHeight = hasFixedTop ? headerElement.height() : 120;
            }
            $('html, body').animate({
                scrollTop: element.offset().top - headerHeight
            }, duration);
        }
    }
    /**
     * Scroll a body to a particular distance
     * @param  {number} x
     * @param  {number} y
     * @param  {number} duration
     * @returns void
     */
    scrollByValue(x, y, duration) {
        $('html, body').animate({
            scrollLeft: x,
            scrollTop: y
        }, duration);
    }
    /**
     * @returns number
     */
    totalSavingsCalc(product, memberTitleId, wholesaleQualified, optin) {
        const discountPercenatge = this.getDiscountPerc();
        let totalSavings = ((discountPercenatge * Number(product.retailPrice.toFixed(2))) / 100);
        if (memberTitleId !== MemberLevel.PREFERREDCUSTOMER) {
            totalSavings = (product.retailPrice - product.wholesalePrice) + totalSavings;
        }
        return totalSavings;
    }
    /**
     * @description discount percentage based on UserTitleType
     * @param {number} memberTitleId
     * @param {boolean} wholesaleQualified
     * @returns {number}
     * @memberof CommonService
     */
    getDiscountPerc() {
        let discountPercenatge = 0;
        const memberDiscountDetails = this._cacheService.get(CacheKey.MemberDiscountPercentage);
        if (memberDiscountDetails && memberDiscountDetails.discountPercentage) {
            discountPercenatge = memberDiscountDetails.discountPercentage;
        }
        return discountPercenatge;
    }
    /**
     * get user types from member titles table
     * @returns Observable
     */
    getUserTypes() {
        return this._http
            .get(ApiUrlConstants.configurationApiUrl + 'stores/memberTitles')
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * @description get purchase flow type
     * @returns {*}
     * @memberof CommonService
     */
    getPurchaseFlowType() {
        const userInfo = this._cacheService.get(CacheKey.UserInfo);
        if (userInfo && (userInfo.memberTypeId === MemberType.DISTRIBUTOR
            || (userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER && userInfo.wholesaleQualified))) {
            return PurchaseFlow.PERSONAL;
        }
        else if (userInfo && (userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER && !userInfo.wholesaleQualified)) {
            return this.appConfig.fpc5PercentEnabled ? PurchaseFlow.FPC5PERCENT : PurchaseFlow.PERSONAL;
        }
        else {
            return PurchaseFlow.RETAIL;
        }
    }
    getCardsContentBySitemapId(sitemapId) {
        const store = this._configurationService.getStoreData();
        return this._http
            .get(ApiUrlConstants.cmsApiURL + '/portals/' + environment.portalId + '/countries/'
            + store.homeIsocodeThree.toLowerCase() + '/languages/' + this.languageCode + '/dynamic/' + sitemapId)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * To get all product caterories from the service
     * @param  {number} groupId
     * @returns Observable
     * With RxJS EMPTY, success callback will not get trigger. It will trigger complete only
     */
    getCategories(storeId, groupId, languageCode) {
        const memberTitleId = this._activeSessionService.getMemberTitleIdForProducts();
        const userInfo = this._cacheService.get(CacheKey.UserInfo);
        const storeConfig = this._configurationService.getStoreData();
        const purchaseFlowType = this.getPurchaseFlowType();
        const wholesaleQualified = userInfo ? userInfo.transactionalWholesaleQualified : false;
        const _cateroriesUrl = ApiUrlConstants.productApiUrl + '/v1/stores/' + storeId +
            '/category-groups/' + groupId + '?languageCode=' + this.languageCode + '&memberTitleId=' + memberTitleId +
            '&purchaseFlowType=' + purchaseFlowType + '&countryCode=' + this.isoCountryCode + '&wholesaleQualified=' + wholesaleQualified
            + '&optin=' + (userInfo ? userInfo.transactionalOptin : false)
            + '&taxInclusive=' + storeConfig.taxInclusive;
        return this._http
            .get(_cateroriesUrl)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * To get recent products
     * @param  {number} storeId
     * @returns Observable
     */
    getProductsByIds(browsedProducts, languageCode, storeId) {
        const storeConfig = this._configurationService.getStoreData();
        const userInfo = this._cacheService.get(CacheKey.UserInfo);
        const memberTitleId = this._activeSessionService.getMemberTitleIdForProducts();
        const purchaseFlowType = this.getPurchaseFlowType();
        const wholesaleQualified = userInfo ? userInfo.transactionalWholesaleQualified : false;
        let _productsUrl = ApiUrlConstants.productApiUrl + '/v1/stores/products/recentlyviewed?storeId=' + storeId +
            '&productIds=' + browsedProducts.join(',') + '&languageCode=' + this.languageCode +
            '&memberTitleId=' + memberTitleId + '&purchaseFlowType=' + purchaseFlowType + '&countryCode=' +
            this.isoCountryCode + '&wholesaleQualified=' + wholesaleQualified
            + '&optin=' + (userInfo ? userInfo.transactionalOptin : false)
            + '&taxInclusive=' + storeConfig.taxInclusive;
        const priceTierId = this.getMemberSalePromotionPriceTierId();
        if (priceTierId) {
            _productsUrl += '&priceTierId=' + priceTierId;
        }
        return (this._http
            .get(decodeURIComponent(encodeURIComponent(_productsUrl)))
            .pipe(catchError(this.handleErrorObservable)));
    }
    /**
     * @returns boolean
     */
    getWholesaleQualified() {
        const userInfo = this._cacheService.get(CacheKey.UserInfo);
        return userInfo && userInfo.wholesaleQualified ? userInfo.wholesaleQualified : false;
    }
    /**
    * @returns Observable
    */
    getApplicationSites(portalId, storeId, countryId, languageCode, memberTypeId) {
        try {
            languageCode = JSON.parse(languageCode);
        }
        catch (e) {
            languageCode = languageCode;
        }
        const appMenusUrl = ApiUrlConstants.configurationApiUrl + 'portals/' + portalId +
            '/Stores/' + storeId + '/' + countryId + '/' + languageCode + '?memberTypeId=' + memberTypeId;
        // let _menusUrl: string = environment.uiTemplateBaseUrl + '/test/' + siteName + '-menu-items.json';
        return this._http.get(appMenusUrl)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
       * get the Application Second level Menus
       * @returns {Observable<any[]>}
       * @memberof CommonService
       */
    getApplicationMenus() {
        // const localMenuURL = environment.uiTemplateBaseUrl + '/test/second-level-menu.json';
        const localMenuURL = environment.cdnURL + '/flpi/catalog-json/second-level-menu.json';
        return this._http.get(localMenuURL)
            .pipe(mergeMap((res) => {
            return this.validateMenus(res);
        }), catchError(this.handleErrorObservable));
    }
    validateMenus(menus) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let filteredMenus = new Array();
            let authService = this._authService;
            return new Promise(function (resolve, reject) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (menus !== null && menus !== undefined
                        && menus.length > 0) {
                        for (const menu of menus) {
                            let privileges = new Array();
                            privileges.push(menu.featureName);
                            yield authService.hasPrivilege(privileges).then(res => {
                                if (res) {
                                    filteredMenus.push(menu);
                                }
                            });
                        }
                    }
                    resolve(filteredMenus);
                });
            });
        });
    }
    /**
       * Performs any type of http request.
       * @param url
       * @param options
       * @returns {Observable<Response>}
       */
    getPortalCountries() {
        const url = ApiUrlConstants.configurationApiUrl + 'portals/' + environment.portalId + '/countries';
        if (environment.betaPortal === false && this.getBetaCountries().length !== 0) {
            return this._http
                .get(url)
                .pipe(map(res => {
                res = this.updateTitanPlatformFlagsForBetaCountries(res);
                return res;
            }), catchError(this.handleErrorObservable));
        }
        else {
            return this._http
                .get(url)
                .pipe(catchError(this.handleErrorObservable));
        }
    }
    updateTitanPlatformFlagsForBetaCountries(regions) {
        let processedregions = [];
        let betaEnabledCountries = this.getBetaCountries();
        if (regions !== null && regions !== undefined && regions.length > 0) {
            for (let region of regions) {
                if (region.countries !== null && region.countries !== undefined && region.countries.length > 0) {
                    for (let country of region.countries) {
                        if (betaEnabledCountries.includes(country.isocodeThree.toLowerCase())) {
                            country.titanPlatformEnabled = false;
                        }
                    }
                }
            }
        }
        return regions;
    }
    getBetaCountries() {
        let betaCountries = [];
        if (environment.betaEnabledCountries !== undefined && environment.betaEnabledCountries !== null
            && environment.betaEnabledCountries !== '') {
            betaCountries = environment.betaEnabledCountries.toLowerCase().split(',');
        }
        return betaCountries;
    }
    /**
     * for qa demo we are doing this changes later we will remove
     * @param  {string} isoTwoCode
     * @returns string
     */
    getISOThreeLetterCountryCode(isoThreeCode) {
        return isoThreeCode;
    }
    /**
     * @description To avoid screen flicker, while opening modal popup.
     * @param {boolean} onShow
     * @memberof CommonService
     */
    jumpingScroll(onShow) {
        const body = document.body;
        if (body) {
            const offset = (window.innerWidth - body.clientWidth);
            if (onShow) {
                $('#global-banner').css({ 'left': -offset + 'px' });
                // body.style.paddingRight = offset + 'px';
            }
            else {
                $('#global-banner').css({ 'left': '0px' });
                // body.style.paddingRight = '0px';
            }
        }
    }
    navigateToLegacy(countryCode) {
        const body = { 'countryCode': countryCode, 'portal': 'Account' };
        return this._http.post(this._accountServiceUrl + 'sso/legacy/login', body)
            .map((response) => response)
            .catch(this.handleErrorObservable);
    }
    getLanguageCode() {
        let languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
        if (languageCode === undefined || languageCode === null || languageCode === '') {
            const storeConfig = this._cacheService.get(CacheKey.StoreConfiguration);
            if (storeConfig !== undefined && storeConfig !== null &&
                storeConfig.languages !== undefined && storeConfig.languages !== null) {
                const languages = storeConfig.languages;
                languageCode = languages.find((x) => x.default === true) || languages[0];
            }
        }
        return languageCode;
    }
    /**
    * Get Configuration based on sitemapNode
    *
    * @returns {Observable <any>}
    */
    getCMSWidgetConfiguration() {
        return this._http.get(this.cmsWidgetConfigUrl).map((res) => res.json());
    }
    /**
    * Checks whether mobile device or not
     * @returns Boolean
     */
    isMobileDevice() {
        if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
    * To get the cms data
    * @param  {string} sitemapId
    * @param  {string} country
    * @param  {string} languageId
    * @returns Observable
    */
    getCMSContentBySiteMapId(menuId, countryCode, storeId, portalId) {
        const store = this._configurationService.getStoreData();
        return this._http
            .get(ApiUrlConstants.cmsApiURL + '/portals/' + portalId + '/countries/'
            + store.homeIsocodeThree.toLowerCase() + '/languages/' + this.languageCode + '/' + menuId)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
    * @description This method used for clearing keyclock cahce after logout
    * clearKeyCloakCache
    * @param {string} distributorId
    * @returns
    * @memberof CommonService
    */
    clearKeyCloakCache(distributorId) {
        const keyclockCacheUrl = environment.ssoApiUserURL + '/'
            + distributorId + '/clear-cache';
        return this._http.get(keyclockCacheUrl)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
    * focus target element
    * @param {HTMLElement} targetElement
    * @returns void
    */
    focusTargetElement(targetElement) {
        const targetEl = document.getElementById(targetElement);
        if (targetEl) {
            targetEl.focus();
        }
    }
    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    handleErrorObservable(error) {
        return Observable.throw(error.message || error);
    }
    /**
     * @description get Member Action Items
     * @date 2018-10-05
     * @param {*} countryCode
     * @param {*} memberType
     * @param {number} memberId
     * @returns {Observable<any>}
     * @memberof CommonService
     */
    getMemberActionItems(countryCode, memberId, languageCode, isAcknowledgementReq) {
        let getDocumentsURL = '';
        if (isAcknowledgementReq) {
            getDocumentsURL = ApiUrlConstants.accountApiUrl + '/documents?isAcknowledgementReq=' + isAcknowledgementReq + '&isActionItem=' + true
                + '&countryCode=' + countryCode + '&memberId=' + memberId + '&displaySectionId='
                + DisplaySectionId.MyAction_Center + '&preferredLangCode=' + languageCode + '&portal=' + Portal.Account;
        }
        else {
            getDocumentsURL = ApiUrlConstants.accountApiUrl + '/documents?isActionItem=' + true
                + '&countryCode=' + countryCode + '&memberId=' + memberId + '&displaySectionId='
                + DisplaySectionId.MyAction_Center + '&preferredLangCode=' + languageCode + '&portal=' + Portal.Account;
        }
        return this._http
            .get(getDocumentsURL)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
      * Customer Acknowledgement
      * @param customerAckModel
      */
    customerAknowledgement(customerAckModel) {
        return this._http.post(ApiUrlConstants.accountApiUrl + '/members/' + customerAckModel.memberId + '/acknowledgement', customerAckModel)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * get Admin Token
     */
    getAdminToken() {
        return this._http.get(ApiUrlConstants.accountApiUrl + '/impersonate')
            .pipe(catchError(this.handleErrorObservable));
    }
    saveUserActionsOnActionCenter(request, adminToken, userName) {
        const documentRequest = {
            'documentState': request
        };
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + adminToken);
        return this._http
            .post(environment.ssoApiUserURL + '/' + userName + '/state/' +
            (this._cacheService.get(CacheKey.session_state)), documentRequest, { headers: new HttpHeaders().set('Authorization', 'Bearer ' + adminToken) })
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * To get portal url from portal name
     * @param {string} portalName
     * @returns {string}
     * @memberof CommonService
     */
    getParentUrl(portalName) {
        let url = '';
        switch (portalName) {
            case 'Shop':
                url = environment.shopURL;
                break;
            case 'Account':
                url = environment.accountSiteURL;
                break;
            case 'Reports':
                url = environment.reportsURL;
                break;
            case 'Corporate':
                url = environment.corporateUrl;
                break;
            case 'Join':
                url = environment.enrollSiteURL;
                break;
        }
        return url;
    }
    downloadFile(documentURL) {
        return this._http.get(documentURL, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }), responseType: 'blob'
        }).pipe(tap(data => console.log('You received data'), error => console.log(error)));
    }
    /**
     * Get Member allowed Resources based on MemberType
     * @param memberType
     */
    getMemberAllowedResources(memberType) {
        return this._http.get(ApiUrlConstants.accountApiUrl + '/member-types/' + memberType + '/privileges')
            .pipe(mergeMap((res) => {
            return this.validateMemberAllowedResources(res);
        }), catchError(this.handleErrorObservable));
    }
    validateMemberAllowedResources(memberPrivileges) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let filteredPrivileges = new Array();
            let authService = this._authService;
            return new Promise(function (resolve, reject) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (memberPrivileges !== null && memberPrivileges !== undefined
                        && memberPrivileges.length > 0) {
                        for (const prv of memberPrivileges) {
                            let privileges = new Array();
                            privileges.push(prv.resource.replace(/ /g, ""));
                            yield authService.hasPrivilege(privileges).then(res => {
                                if (res) {
                                    filteredPrivileges.push(prv);
                                }
                            });
                        }
                    }
                    resolve(filteredPrivileges);
                });
            });
        });
    }
    /**
    * to get all the countries
    */
    getCountries() {
        return this._http
            .get(ApiUrlConstants.configurationApiUrl + 'countries')
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
    * Prepare left side menu navigation
     * @description
     * @date 2019-02-12
     * @param {MemberPrivilege[]} memberPrivileges
     * @param {boolean} isImpersonatedUser
     * @returns {MemberAllowedResources[]}
     * @memberof CommonService
     */
    prepareLeftMenuNavigation(memberPrivileges, isImpersonatedUser) {
        if (memberPrivileges && memberPrivileges.length > 0) {
            const userInfo = this._cacheService.get(CacheKey.UserInfo);
            const memberAllowedResources = [];
            MemberResourcesConstants.memberAllowedResources.forEach(x => {
                const memberPrivilege = memberPrivileges.find(item => item.id === x.id);
                const isHomeCountry = this.isHomeCountry(userInfo);
                if (memberPrivilege) {
                    if (memberPrivilege.id === MemberAllowedResourcesLookup.DashBoard) {
                        memberAllowedResources.push(this.constructMemberAllowedResource(x, memberPrivilege.resource));
                    }
                    else if (memberPrivilege.id === MemberAllowedResourcesLookup.ForeverBusinessOwnerSetup
                        && userInfo && userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER && isHomeCountry) {
                        const hasUpgradeAsFBO = this._cacheService.get(CacheKey.HasUpgradeAsFBO);
                        if (!hasUpgradeAsFBO) {
                            memberAllowedResources.push(this.constructMemberAllowedResource(x, memberPrivilege.resource));
                        }
                    }
                    else if (memberPrivilege.id === MemberAllowedResourcesLookup.Password) {
                        memberAllowedResources.push(this.constructMemberAllowedResource(x, memberPrivilege.resource, isImpersonatedUser));
                    }
                    else {
                        memberAllowedResources.push(this.constructMemberAllowedResource(x, memberPrivilege.resource));
                    }
                }
            });
            return memberAllowedResources;
        }
    }
    /**
    * checks whether the selected country is home country
    * @returns {boolean}
    * @memberof CommonService
    */
    isHomeCountry(userInfo) {
        this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode).toUpperCase();
        if (userInfo && userInfo.homeCountryCode && this.isoCountryCode) {
            return userInfo.homeCountryCode.toUpperCase() === this.isoCountryCode.toUpperCase();
        }
        return false;
    }
    /**
     * Prepare Member allowed resources model
     * @param memberAllowedResource
     * @param resourceName
     * @param showLink
     */
    constructMemberAllowedResource(memberAllowedResource, resourceName, showLink) {
        if (this._cacheService.get(CacheKey.CountryMetaData)) {
            this.updateCountryCodeinCookie();
        }
        const isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        const languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
        if (memberAllowedResource && isoCountryCode && languageCode) {
            const resource = {
                id: memberAllowedResource.id,
                resource: resourceName,
                resourceUrl: memberAllowedResource.resourceUrl ? environment.accountSiteURL + '/' +
                    isoCountryCode.toLowerCase() + '/' + languageCode.toLowerCase()
                    + memberAllowedResource.resourceUrl : '',
                icon: memberAllowedResource.icon,
                showLink: showLink
            };
            return resource;
        }
    }
    /**
    * Get Member allowed Countries based on MemberType
    * @param memberId
    */
    getMemberAllowedCountries(memberId) {
        return this._http
            .get(ApiUrlConstants.accountApiUrl + '/members/' + memberId + '/allowed-countries?mappedEligibilities=true')
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * @description to get member information based on memberID
     * @param {number} memberId
     * @returns {Observable<Member>}
     * @memberof CommonService
     */
    getMemberDetails(distributorId) {
        return this._http
            .get(ApiUrlConstants.accountApiUrl + '/member-details?distributorId=' + distributorId)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     *
     *@description to get Specific member information based on memberID
     * @param {string} distributorId
     * @param {string} params
     * @returns {Observable<Member>}
     * @memberof CommonService
     */
    getMemberSpecificDetails(distributorId, params) {
        return this._http
            .get(ApiUrlConstants.accountApiUrl + '/member-specific-details?distributorId=' + distributorId + '&options=' + params)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Encode image url
     * @param {string} url
     * @returns {string}
     * @memberof CommonService
     */
    encodeImageURL(url) {
        if (url) {
            return url.replace(/ /g, '%20');
        }
        return url;
    }
    /**
     * Sponsor Search
     * @param  {any} sponsorSearchRequest
     * @param  {number} limit?
     * @returns Observable
     */
    searchSponsors(sponsorSearchRequest, limit) {
        const _searchSponsorUrl = ApiUrlConstants.accountApiUrl +
            '/sponsor-search';
        return this._http
            .post(_searchSponsorUrl, sponsorSearchRequest)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
    * @description this method will  get sponsor by uuid
    * @date 2019-03-18
    * @returns {Observable<SponsorInformation>}
    * @memberof SponsorService
    */
    getSearchSponsorsByUUID(sponsorSearchResponse) {
        const _searchSponsorUrl = sponsorSearchResponse.location;
        return this._http
            .get(decodeURIComponent(encodeURIComponent(_searchSponsorUrl)))
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     * @description get Map locations
     * @date 2019-11-11
     * @returns {Observable<MapLocationInfo[]>}
     * @memberof
     */
    getMapLocations() {
        const getURL = environment.cdnURL + '/locations/maplocations.json';
        return this._http
            .get(getURL)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
     *
     */
    checkSkipNavigation(countryCode) {
        let betaCountries = this.getBetaCountries();
        let skipNavigation = true;
        if (betaCountries !== undefined && betaCountries !== null && betaCountries.length > 0) {
            skipNavigation = !betaCountries.includes(countryCode.toLowerCase());
        }
        return skipNavigation;
    }
    /**
     *
     * @param url
     */
    navigateToInternalPreview(url) {
        let redirectHostName = new URL(url).hostname;
        redirectHostName = redirectHostName.replace('.com', '');
        if (redirectHostName && redirectHostName.includes('.')) {
            const redirectDomainParts = redirectHostName.split('.');
            const redirectSubDomain = redirectDomainParts[0];
            return this.isTitanSubDomain(redirectSubDomain, url);
        }
        else {
            if (url.toLowerCase().includes(environment.legacyURL)) {
                return false;
            }
            else if (this.checkAppRoute(url)) {
                return true;
            }
        }
        return false;
    }
    isTitanSubDomain(subDomain, url) {
        if (subDomain && environment.joinPortalSubDomainName &&
            subDomain.toLowerCase().includes(environment.joinPortalSubDomainName)) {
            return true;
        }
        else if (subDomain && environment.shopPortalSubDomainName &&
            subDomain.toLowerCase().includes(environment.shopPortalSubDomainName)) {
            return true;
        }
        else if (subDomain && environment.accountPortalSubDomainName &&
            subDomain.toLowerCase().includes(environment.accountPortalSubDomainName)) {
            return true;
        }
        else if ((subDomain && subDomain.toLowerCase().includes('corporate')) || subDomain.toLowerCase().includes('preview') ||
            (url.toLowerCase().includes(SharedConstants.PREVIEW_BASE_URL) && !url.toLowerCase().includes(environment.legacyURL))) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     *
     * @param countryCode ISO Three Digit Country code
     */
    betaCountry(countryCode) {
        let betaCountries = this.getBetaCountries();
        let betaCountry = false;
        if (betaCountries !== undefined && betaCountries !== null && betaCountries.length > 0) {
            betaCountry = betaCountries.includes(countryCode.toLowerCase());
        }
        return betaCountry;
    }
    /**
     * @description Append Sponsor Id
     * @author njagadeesan
     * @date 2020-01-20
     * @param {string} route
     * @returns {string}
     * @memberof CommonService
     */
    appendFBOID(route, isLegacy) {
        const shareFBOID = this._cacheService.getSessionValue(CacheKey.fboId);
        if (shareFBOID && route) {
            const delimiter = route.indexOf('?') > -1 ? '&' : '?';
            let param = null;
            if (route.indexOf('#') > -1) {
                route = this.updateUrlParameter(route, isLegacy ? 'distribID' : 'fboId', shareFBOID);
            }
            else {
                param = isLegacy ? 'distribID=' : 'fboId=';
                route = route + delimiter + param + shareFBOID;
            }
            const memberSalePromotionModel = this._cacheService.getSessionValue(CacheKey.MemberSalePromotionModel);
            if (!isLegacy && memberSalePromotionModel) {
                const promotionModel = JSON.parse(memberSalePromotionModel);
                route = route + '&code=' + promotionModel.code + '&discountConfigType=' + promotionModel.discountConfigType;
            }
        }
        return route;
    }
    // Add / Update a key-value pair in the URL query parameters
    updateUrlParameter(uri, key, value) {
        // remove the hash part before operating on the uri
        const i = uri.indexOf('#');
        const hash = i === -1 ? '' : uri.substr(i);
        uri = i === -1 ? uri : uri.substr(0, i);
        // tslint:disable-next-line:quotemark
        const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            uri = uri.replace(re, '$1' + key + '=' + value + '$2');
        }
        else {
            uri = uri + separator + key + '=' + value;
        }
        return uri + hash;
    }
    /**
     * @description To check Whether it is Internal portals
     * @author njagadeesan
     * @date 2020-01-20
     * @param {string} url
     * @returns {boolean}
     * @memberof CommonService
     */
    checkAppRoute(url) {
        if (url && url.indexOf(environment.cookieDomain.substr(1)) > -1) {
            return true;
        }
        return false;
    }
    /**
    * @description To Check Legacy Shop or Join
    * @author njagadeesan
    * @date 2020-02-05
    * @param {string} url
    * @returns {boolean}
    * @memberof CommonService
    */
    legacyShopOrJoin(url) {
        if (url && url.toLowerCase().startsWith(environment.legacyJoinUrl.toLowerCase())
            || url.toLowerCase().startsWith(environment.legacyShopUrl.toLowerCase()) ||
            url.toLowerCase().startsWith(SharedConstants.LEGACY_JOIN_MOBILE_URL.toLowerCase())) {
            return true;
        }
        return false;
    }
    /**
   * Navigate to BETA portal
   * @param route
   */
    constructBetaUrl(route) {
        if (route !== undefined && route !== null && route !== '') {
            let url = new URL(route);
            let redirectHostName = this.findOutPortal(url.host, route);
            if (redirectHostName !== undefined && redirectHostName !== '') {
                let newRedirectUrl = redirectHostName + url.pathname + url.search;
                return newRedirectUrl;
            }
        }
        return route;
    }
    /**
     * Extract Portal
     */
    findOutPortal(url, routeUrl) {
        if (environment.joinPortalSubDomainName && url.toLowerCase().includes(environment.joinPortalSubDomainName)) {
            return environment.enrollSiteURL;
        }
        else if (environment.shopPortalSubDomainName && url.toLowerCase().includes(environment.shopPortalSubDomainName)) {
            return environment.shopURL;
        }
        else if (environment.accountPortalSubDomainName && url.toLowerCase().includes(environment.accountPortalSubDomainName)) {
            return environment.accountSiteURL;
        }
        else if (environment.corporatePortalSubDomainName && url.toLowerCase().includes(environment.corporatePortalSubDomainName) || this.isTitanCorporate(routeUrl)) {
            return environment.corporateUrl;
        }
        else {
            return '';
        }
    }
    isTitanCorporate(route) {
        let url = new URL(route);
        if (url && url.host
            && url.host.startsWith(environment.cookieDomain.substr(1))
            && route.indexOf(environment.legacyURL) === -1) {
            return true;
        }
        return false;
    }
    /**
     * This method used to get configured url
     * getConfigurationURL
     */
    getCountryConfigurationURL(country, item) {
        let url = '';
        switch (item) {
            case HamburgerItemConstants.SHOP:
                url = country.shopUrl;
                break;
            case HamburgerItemConstants.JOIN:
                url = country.enrollmentUrl;
                break;
            case HamburgerItemConstants.LOGIN:
                url = country.loginUrl;
                break;
            case HamburgerItemConstants.ABOUT:
                url = country.shopUrl;
                break;
            default:
                url = '';
                break;
        }
        return url;
    }
    /**
   * This method used to verify the flp360 access by fboid
   * verifyFlp360Access()
   */
    verifyFlp360Access(fboId) {
        const url = ApiUrlConstants.accountApiUrl + '/flp360/verify/' + fboId;
        return this._http.get(url)
            .pipe(catchError(this.handleErrorObservable));
    }
    /**
    * get member vat and discount info
    */
    getMemberVatAndDiscountInfo(userInfo, taxCalculated) {
        let memberVatAndDiscountInfo;
        if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR) {
            memberVatAndDiscountInfo = {
                discountPercentage: this.getDiscountPerc(),
                vatRegistered: userInfo.vatRegistered ? true : false,
                taxCalculated: taxCalculated,
                memberTitleId: userInfo.memberTitleId,
                transactionalOptin: userInfo.transactionalOptin ? true : false,
                transactionalWholesaleQualified: userInfo.transactionalWholesaleQualified ? true : false,
                enableWHLSAL00ForAsstSupervisor: this.getEnableWHLSALForAsstSupervisor()
            };
        }
        return memberVatAndDiscountInfo;
    }
    /**
     * @description To Check stanalone page or not
     * @author njagadeesan
     * @date 2020-03-24
     * @param {string} url
     * @returns {string}
     * @memberof CommonService
     */
    isEventsPage(url) {
        if (url) {
            const eventPage = SharedConstants.EVENT_PAGES.find((page) => {
                return url.toLowerCase().indexOf(page.toLowerCase()) > -1;
            });
            return eventPage;
        }
        return null;
    }
    /**
     * to get enable wholesale price flag for assistant supervisor
     * getEnableWHLSALEForAsstSupervisor()
     */
    getEnableWHLSALForAsstSupervisor() {
        const isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        const enabledCountries = isoCountryCode && environment.enableWHLSAL00ForAsstSupervisor ?
            environment.enableWHLSAL00ForAsstSupervisor.split(',') : null;
        const country = enabledCountries && enabledCountries.length ? enabledCountries.find(item => item.toLowerCase() === isoCountryCode.toLowerCase()) : null;
        return country ? false : true;
    }
    /**
     * prepareMemberDisplayConfigInfo()
     *
     * @returns Observable
     */
    prepareMemberDisplayConfigInfo(displayPage, taxInclusiveStore, userInfo, taxCalculated, taxInclusiveShippingCountry) {
        const shareFBOID = this._cacheService.getSessionValue(CacheKey.fboId) || null;
        const memberSalePromotionModel = this._cacheService.getSessionValue(CacheKey.MemberSalePromotionModel) || null;
        const memberDisplayConfigInfo = {
            userInfo: userInfo,
            taxInclusiveStore: taxInclusiveStore,
            displayPage: displayPage,
            taxCalculated: taxCalculated,
            taxInclusiveShippingCountry: taxInclusiveShippingCountry,
            shareFBOID: shareFBOID,
            memberSalePromotionModel: memberSalePromotionModel,
            enableWHLSAL00ForAsstSupervisor: this.getEnableWHLSALForAsstSupervisor()
        };
        return memberDisplayConfigInfo;
    }
    getMemberSalePromotionPriceTierId() {
        let priceTierId;
        const memberSalePromotionModel = JSON.parse(this._cacheService
            .getSessionValue(CacheKey.MemberSalePromotionModel));
        if (memberSalePromotionModel && memberSalePromotionModel.discountConfigType
            && memberSalePromotionModel.code) {
            priceTierId = memberSalePromotionModel.discountConfigType;
        }
        return priceTierId;
    }
    /**
    * To handle the obervable error response
    * @param  {Response|any} error
    */
    handleError(error) {
        if (error && error.status >= 500) {
            const errorMsg = error.json();
            if (errorMsg) {
                return {
                    errorGuid: errorMsg.errorId
                };
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }
    getmappedcountries(countryCode) {
        const getMappedCountryUrl = ApiUrlConstants.configurationApiUrl + 'countries/' + countryCode + '/MappedCountries';
        return this._http
            .get(decodeURIComponent(encodeURIComponent(getMappedCountryUrl)))
            .pipe(catchError(this.handleErrorObservable));
    }
    updateCountryCodeinCookie() {
        let countryMetaData = JSON.parse(this._cacheService.get(CacheKey.CountryMetaData));
        if (countryMetaData && countryMetaData.countryID && countryMetaData.countryCode) {
            const storeCountry = countryMetaData.value.split(",");
            let storeIsoThreeCode;
            let countryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
            if (storeCountry && storeCountry.length > 0 && countryCode) {
                storeIsoThreeCode = storeCountry.find(x => x.toLowerCase() === countryCode.toLowerCase());
            }
            if (storeIsoThreeCode) {
                this._cacheService.setCookieValue(CacheKey.countryCode, countryMetaData.countryCode.toLowerCase());
                this._cacheService.setCookieValue(CacheKey.CountryId, countryMetaData.countryID);
                if (countryMetaData.countryLanguages) {
                    let selectedLanguage = this._cacheService.getCookieValue(CacheKey.languageCode) ? countryMetaData.countryLanguages.find(x => x.languageCulture.toLowerCase() === this._cacheService.getCookieValue(CacheKey.languageCode).toLowerCase()) : null;
                    if (!selectedLanguage) {
                        const storeDefault = countryMetaData.countryLanguages.find((x) => x.default === true) || countryMetaData.countryLanguages[0];
                        const defaultLang = countryMetaData.countryLanguages.find((x) => x.languageCultureId === storeDefault.languageCultureId);
                        this._cacheService.setCookieValue(CacheKey.languageCode, defaultLang.languageCulture);
                    }
                }
            }
        }
    }
}
